import React from 'react';
import Modal from './Modal';

/**
 * Confirmation dialog for deleting a record.
 *
 * Before: had its own copy of modalOverlayStyle, modalContentStyle,
 * buttonGroupStyle — about 30 lines of duplicate style objects.
 * Now uses the shared Modal shell.
 */
export default function DeleteConfirmModal({ isOpen, onClose, onConfirm, recordName }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm Delete"
      width="max-w-sm"
      footer={
        <div className="flex justify-center gap-4 mt-5">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium rounded bg-gray-500 text-white cursor-pointer hover:bg-gray-600 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium rounded bg-red-600 text-white cursor-pointer hover:bg-red-700 transition-colors"
          >
            Delete
          </button>
        </div>
      }
    >
      <div className="text-center">
        <p>
          Are you sure you want to delete <strong>{recordName}</strong>?
        </p>
        <p className="text-sm text-gray-500 mt-1">This action cannot be undone.</p>
      </div>
    </Modal>
  );
}
